export enum CardBrandDisplayName {
  jcb = "JCB",
  amex = "American Express",
}
